import Progress from '@/components/dataDisplay/Progress';
import Skeleton from '@/components/dataDisplay/Skeleton';
import Button from '@/components/input/Button';
import { routes as routingRoutes } from '@/constants/routes';
import theme from '@/constants/theme';
import { Route } from '@/services/routes/route.vm';
import { EmojiEvents } from '@mui/icons-material';
import React from 'react';
import { generatePath, useNavigate } from 'react-router';

interface Props {
  routes: Route[];
  loading: boolean;
}

const ContinueProgressing: React.FC<Props> = ({ routes, loading }) => {
  const navigate = useNavigate();

  const nextContent = routes.find((route) => route.progressStatus === 'IN_PROGRESS');

  const handlePress = () => {
    if (!nextContent) return;
    navigate(generatePath(routingRoutes.routes.detail, { routeId: nextContent.id }));
  };

  if (loading) return <Skeleton width="100%" height="300px" borderRadius="8px" />;

  if (!nextContent) {
    return <img src={require('@/assets/images/home-image.png')} alt="home" style={styles.headerImage} />;
  }

  return (
    <div style={styles.container}>
      <div style={styles.titleContainer}>
        <h2 style={styles.title}>¡Sigue donde lo dejaste!</h2>
        <p style={styles.description}>Mantente motivado y sigue aprendiendo con tus rutas de aprendizaje.</p>
      </div>
      <EmojiEvents style={styles.markIcon} />
      <div style={styles.contentContainer}>
        <div style={styles.progressContainer}>
          <h3 style={styles.routeTitle}>{nextContent?.title}</h3>
          <span style={styles.progress}>{Math.floor(nextContent?.progress ?? 0)}%</span>
        </div>
        <Progress value={nextContent?.progress ?? 0} />
        <Button sx={{ fontWeight: 'bold', justifyContent: 'center' }} onClick={handlePress}>
          Continuar
        </Button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: '24px 16px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.default,
    borderBottomRightRadius: 24,
    borderBottomLeftRadius: 24,
    position: 'relative',
  },
  markIcon: {
    fontSize: '130px',
    color: theme.colors.text.default,
    opacity: 0.2,
    position: 'absolute',
    right: 20,
    top: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: 'clamp(200px, 60%, 1000px)',
  },
  title: {
    color: theme.colors.text.default,
  },
  description: {
    color: theme.colors.text.body,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    backgroundColor: theme.colors.background.primary,
    padding: 16,
    borderRadius: 16,
  },
  progressContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  routeTitle: {
    color: theme.colors.text.default,
    fontWeight: 'bold',
  },
  progress: {
    color: theme.colors.text.caption,
    fontSize: 24,
    fontWeight: 'bold',
  },
  headerImage: {
    width: '100%',
    height: 240,
    objectFit: 'cover',
  },
};

export default ContinueProgressing;
